import Popup from "reactjs-popup";
import React from "react";
import "./ToolTip.scss";

export interface ToolTipProps {
    text: string;
    dataTestIdTrigger?: string;
    dataTestIdContent?: string;
}

const ToolTip = (props: ToolTipProps) => (
    <Popup trigger={() => <i className="icon-info tool-tip-icon" data-test={props.dataTestIdTrigger}></i>} position="top center" closeOnDocumentClick>
        <div className="modal" data-test={props.dataTestIdContent}>
            {props.text}
        </div>
    </Popup>
);

export default ToolTip;
